<template>
  <section>
    <!--工具条-->
    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addFormVisible = true">新增</el-button>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading">
      <el-table-column
        label="名称"
        prop="title"
        align="center">
      </el-table-column>

      <el-table-column
        label="排序"
        prop="sort"
        align="center">
      </el-table-column>
      <el-table-column
        label="指向地址"
        prop="href"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
            <el-table-column
        label="状态"
        prop="status"
        align="center">
        <template scope="scope">
          {{status[scope.row.status]}}
        </template>
      </el-table-column>
      
      <el-table-column
        label="操作"
        prop="event_unique_key"
        align="center">
        <template scope="scope">
          <el-button v-if="scope.row.pic" :plain="true" type="info" size="small" @click="showUploadForm(scope.row)">修改图片</el-button>
          <el-button v-else :plain="true" type="info" size="small" @click="showUploadForm(scope.row)">上传图片</el-button>
          <el-button :plain="true" type="info" size="small" @click="showEditForm(scope.row)">修改</el-button>
          <el-button :plain="true"  v-if="scope.row.status == 0" type="danger" size="small" @click="deleteDate(scope.row)">删除</el-button>
            <el-button v-else :plain="true" type="danger" size="small" @click="deleteDate(scope.row)">恢复</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="名称" prop="title">
          <el-input v-model="addForm.title" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="指向地址" prop="href">
          <el-input v-model="addForm.href" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="addForm.sort" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="名称" prop="title">
          <el-input v-model="editForm.title" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="指向地址" prop="href">
          <el-input v-model="editForm.href" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="editForm.sort" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--上传图片-->
    <el-dialog title="上传图片" v-model="uploadPicVisible" class="dialog-upload" size="tiny">
      <el-upload
        class="avatar-uploader"
        action="https://up.qbox.me"
        :show-file-list='showUploadList'
        :on-success="handleSuccess"
        :on-error="handleError"
        :before-upload="beforeUpload"
        :data='uploadForm'>
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="uploadSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';
  import {formatDate} from '../../static/js/date.js';
  import {getQiniuToken} from '../../static/js/token.js'
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          adver_id: 0,
          title: '',
          sort: 0,
          href: '',
          create_time: '',
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {},
        uploadPicVisible: false,
        showUploadList: false,
        uploadForm: {
          token: getQiniuToken(),
          key: null
        },
        adverId: 0,
        imageUrl: '',
        id: 0,
        status: basicdata.status
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getAdverPic(this.adverId);
      },
      getAdverPic(adverId) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/adverpic/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": adverId
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
          } else {
            this.$message({
              message: data.msg,
              type: 'warning'
            });
          }
          this.listLoading = false;
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.addForm));
              para.sort = parseInt(para.sort);
              para.adver_id = parseInt(this.adverId);
              //异步请求
              this.$axios.post(config.api_url + '/adverpic',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.editForm));
              para.sort = parseInt(para.sort);
              //异步请求
              this.$axios.put(config.api_url + '/adverpic',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
           deleteDate(row) {
        let text = '是否删除？';
        let status = 1;
        if(row.status == 1) {
          text = '是否恢复？'
          status = 0
        }
        this.$confirm(text, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.delete(config.api_url + '/adverpic/' + row.id + '/' + status
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(error => {
            this.$message({
              message: '操作异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      showEditForm(row) {
        this.editFormVisible = true;
        this.editForm = row;
      },
      showUploadForm(row) {
        this.uploadPicVisible = true;
        this.id = row.id;
        this.imageUrl = row.pic;
      },
      //上传图片
      beforeUpload (file) {
        let fileName = 'adver/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
        let mime = file.name.split('.')[1];
        fileName += '.' + mime;
        this.uploadForm.key = fileName;
      },
      handleSuccess (response, file, fileList) {
        this.imageUrl = basicdata.picUrl + this.uploadForm.key
        this.result = '上传成功'
      },
      handleError (error, response, file) {
        this.result = error.toString()
      },
      //修改图片
      uploadSubmit() {
        this.$confirm('确认提交吗？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/adverpic/'+this.id+'?pic='+this.imageUrl
          ).then(response => {
              if(response.data.state) {
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.uploadPicVisible = false;
                this.search();
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '提交异常，请联系管理员',
              type: 'error'
            });
          });
        });
      }
    },
    created() {
      this.adverId = this.$route.params.id;
      this.search();
    }
  }
</script>

<style scoped>
  .avatar-uploader {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// Slide.vue?6207bef8